import React from "react";
import { object } from "prop-types";
import get from "lodash/get";
import { connect } from "react-redux";

import SmallStoryCardWithTopBorder from "../molecules/smallStoryCardWithTopBorder";
import { More } from "../atoms/load-more-btn/index";

import "./search.m.css";

const template = stories => {
  return (
    <>
      {stories.map(story => (
        <SmallStoryCardWithTopBorder story={story} key={story.id} />
      ))}
    </>
  );
};

const SearchPageBase = ({ data = {}, hostUrl }) => {
  const stories = data.stories;
  if (!(stories && stories.length)) {
    return null;
  }
  const slug = `${hostUrl}/search?page=${data.pageNumber ? parseInt(data.pageNumber) + 1 : 2}`;

  return (
    <div>
      <h1 styleName="search-title">
        Search - {data.query} ({data.total} results)
      </h1>
      {template(stories.slice(0, 10))}
      {stories.length > 10 && (
        <a styleName="button-container" href={slug}>
          <More text="আরও" />
        </a>
      )}
    </div>
  );
};
SearchPageBase.propTypes = {
  data: object
};

const mapStateToProps = state => {
  return {
    hostUrl: get(state, ["qt", "config", "publisher-attributes", "host_url"], {})
  };
};

export const SearchPage = connect(mapStateToProps)(SearchPageBase);
